import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div className="container" style={{ padding: '100px 20px', textAlign: 'center' }}>
      <div style={{ fontSize: 80, marginBottom: 20 }}>🌐</div>
      <h1 className="text-gradient" style={{ fontSize: 60, marginBottom: 12 }}>404</h1>
      <p style={{ marginBottom: 32 }}>The page you're looking for doesn't exist.</p>
      <Link to="/" className="btn btn-primary btn-lg">Go Home</Link>
    </div>
  );
}
